import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../commonComponents/modal/Modal';
import ModalHeader from '../../../commonComponents/modal/ModalHeader';
import ModalFooter from '../../../commonComponents/modal/ModalFooter';
import { compose } from '../../../services/utilityFunctions';
import withCSRF from '../../../commonComponents/withCSRF';
import translate from '../../../commonComponents/translate';

function RemoveProductVariationModal({ t, index, onRemove, onClose }) {
  const handleCancel = () => onClose(false);

  return (
    <Modal onClose={handleCancel}>
      <div className="modal-dialog">
        <div className="modal-content">
          <ModalHeader title={t('catalog_confirm_remove')} onClose={handleCancel} />
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="portlet-body form">
                  <p style={{ paddingLeft: '20px' }}>{t('catalog_confirm_remove_desc')}</p>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter
            onSave={() => {
              onRemove(index);
            }}
            onCancel={handleCancel}
            saveText={t('confirm')}
            cancelText={t('cancel')}
            saveIsLoader
          />
        </div>
      </div>
    </Modal>
  );
}

RemoveProductVariationModal.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default compose(
  translate,
  withCSRF,
)(RemoveProductVariationModal);
